/**
 * Shared constants for GenericDatepicker.
 */
export const Constants = {
  Views: {
    YEARS: 'years',
    MONTHS: 'months',
    DAYS: 'days',
    TIME: 'time',
  },
  /** CSS theme class suffixes: `.gdp-theme-${name}` */
  Themes: {
    DARK: 'dark',
    SOLARIZED: 'solarized',
    HIGH_CONTRAST: 'high-contrast',
  },
  PICKER_WIDTH: 280,
  CALENDAR_SLOTS: 42,
  SAFE_MARGIN: 10,
  Z_INDEX: 2000,
};
